import React from 'react'

const CTA = () => {
    return (
        <div className='cta'>
            <a href="https://drive.google.com/file/d/1Rfre0xPurGi69PKff8P9ntM_ZqrCgLh7/view" target="_blank" rel="noopener noreferrer" className='btn'>Resume</a>
            <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
    )
}

export default CTA